<template>
  <div class="dashboard">
    <Breadcrumb :currentPage="breadcrumbName" :items="breadcrumbItems" :showAddBtn="true"/>
    <CategoryCard :cards="categoryCards" />
  </div>
</template>

<script>
import Breadcrumb from '../components/common/Breadcrumb.vue';
import CategoryCard from '../components/CategoryCard.vue';

export default {
  name: 'upload',
  components: {
    Breadcrumb,
    CategoryCard,
  },
  data () {
    return {
      breadcrumbName: 'Dashboard',
      breadcrumbItems: [
        {
          text: 'Categories',
          disabled: true,
          to: { path: '/' },
          exact: true,
        },
      ],
      categoryCards: [
        { title: 'Plane', image: "1plane", link: "/categories/plane", flex: 2 },
        { title: 'Bench', image: "2bench", link: "/categories/bench", flex: 2 },
        { title: 'Cabinet', image: "3cabinet", link: "/categories/cabinet", flex: 2 },
        { title: 'Car', image: "4car", link: "/categories/car", flex: 2 },
        { title: 'Chair', image: "5chair", link: "/categories/chair", flex: 2 },
        { title: 'Monitor', image: "6monitor", link: "/categories/monitor", flex: 2 },
        { title: 'Lamp', image: "7lamp", link: "/categories/lamp", flex: 2 },
        { title: 'Speaker', image: "8speaker", link: "/categories/speaker", flex: 2 },
        // { title: 'Firearm', image: "9firearm", link: "/categories/firearm", flex: 2 },
        { title: 'Couch', image: "10couch", link: "/categories/couch", flex: 2 },
        { title: 'Table', image: "11table", link: "/categories/table", flex: 2 },
        { title: 'Cellphone', image: "12cellphone", link: "/categories/cellphone", flex: 2 },
        // { title: 'Watercraft', image: "13watercraft", link: "/categories/watercraft", flex: 2 },
        { title: 'Mug', image: "14mug", link: "/categories/mug", flex: 2 },
      ]
    }
  },
}
</script>
